import { element as $, Component, services } from '@contorion/core';
import { IScrollObserverService } from '../interfaces/scroll-observer-service.interface';

export abstract class ScrollAwareComponent extends Component {
    protected scrollObserverService: IScrollObserverService;

    protected get target(): string {
        return this.element.dataset.target;
    }

    protected get targets(): Array<HTMLElement> {
        if (this.target) {
            return [<HTMLElement> $(this.target)];
        }

        const targetsSelectors: Array<string> = this.element.dataset.targets ?
            JSON.parse(this.element.dataset.targets) : [];

        return targetsSelectors.map((target) => {
            return <HTMLElement> $(target);
        });
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        this.scrollObserverService = await services.get('scroll-observer-service');

        for (const target of this.targets) {
            if (target === null) {
                continue;
            }

            this.scrollObserverService.register(target);
            this.scrollObserverService.subscribeIsWithinViewport(
                target,
                this.onTargetScrollInOut.bind(this)
            );
        }
    }

    protected abstract onTargetScrollInOut(isWithinViewport: boolean): void;
}
